import { post } from '../Services/http';
import { catchError } from './Error.action';

export const STOCK_PRODUCT_LIST = "STOCK_PRODUCT_LIST"
export const STOCK_ERROR = "STOCK_ERROR"
export const UPDATE_IS_STOCK_NOTIFY = "UPDATE_IS_STOCK_NOTIFY"

export const setArticleList = (articleList) => (dispatch, getState) => {
    return post('/api/OnHand', articleList)
        .then(response => response.json())
        .then(data => dispatch(setArticleArray(data)))
        .catch(ex => dispatch(catchError(ex, error => loadError(error))))
}

export const loadError = error => ({
    type: STOCK_ERROR,
    payload: {
        error,
    }
})

export const setArticleArray = data => ({
    type: STOCK_PRODUCT_LIST,
    payload: {
        articlesList: data,
    },
})

export const updateIsStockNotify = (variantSystemId, isStockNotify) => ({
    type: UPDATE_IS_STOCK_NOTIFY,
    payload: { variantSystemId, isStockNotify },
  });
